/**
 * ROOPBANI — Customer Account & Authentication Controller
 * Pure Vanilla JavaScript
 */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     1. Password Visibility Toggle
     -------------------------------------------------------------------------- */
  function initPasswordToggles() {
    document.querySelectorAll('[data-password-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const inputWrap = btn.closest('.rb-field-input-wrap');
        if (!inputWrap) return;
        const input = inputWrap.querySelector('input');
        if (!input) return;

        const isPassword = input.getAttribute('type') === 'password';
        input.setAttribute('type', isPassword ? 'text' : 'password');
        btn.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
        
        // Toggle SVG visibility if multiple SVGs exist
        const eyeIcons = btn.querySelectorAll('.rb-icon');
        if (eyeIcons.length === 2) {
          eyeIcons[0].classList.toggle('rb-hide');
          eyeIcons[1].classList.toggle('rb-hide');
        }
      });
    });
  }

  /* --------------------------------------------------------------------------
     2. Login & Recover Password Form Switcher
     -------------------------------------------------------------------------- */
  function initRecoverFormSwitcher() {
    const loginForm = document.getElementById('CustomerLoginForm');
    const recoverForm = document.getElementById('RecoverPasswordForm');
    const recoverLink = document.getElementById('RecoverPassword');
    const cancelLink = document.getElementById('HideRecoverPasswordLink');

    if (!loginForm || !recoverForm) return;

    function showRecover() {
      loginForm.classList.add('rb-hide');
      recoverForm.classList.remove('rb-hide');
      window.location.hash = '#recover';
    }

    function hideRecover() {
      recoverForm.classList.add('rb-hide');
      loginForm.classList.remove('rb-hide');
      if (window.location.hash === '#recover') {
        history.replaceState(null, null, ' ');
      }
    }

    if (recoverLink) {
      recoverLink.addEventListener('click', (e) => {
        e.preventDefault();
        showRecover();
      });
    }

    if (cancelLink) {
      cancelLink.addEventListener('click', (e) => {
        e.preventDefault();
        hideRecover();
      });
    }

    // Check URL hash on load
    if (window.location.hash === '#recover') {
      showRecover();
    }
  }

  /* --------------------------------------------------------------------------
     3. Customer Account Dashboard Tab Switcher
     -------------------------------------------------------------------------- */
  function initAccountTabs() {
    const navButtons = document.querySelectorAll('[data-account-tab-btn]');
    const tabPanels = document.querySelectorAll('[data-account-tab-panel]');

    if (!navButtons.length || !tabPanels.length) return;

    function activateTab(tabId) {
      navButtons.forEach((btn) => {
        const matches = btn.getAttribute('data-account-tab-btn') === tabId;
        btn.classList.toggle('is-active', matches);
        btn.setAttribute('aria-selected', matches ? 'true' : 'false');
      });

      tabPanels.forEach((panel) => {
        const matches = panel.getAttribute('data-account-tab-panel') === tabId;
        panel.classList.toggle('is-active', matches);
        panel.style.display = matches ? 'block' : 'none';
      });

      if (window.location.hash !== `#${tabId}`) {
        history.replaceState(null, null, `#${tabId}`);
      }
    }

    navButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const tabId = btn.getAttribute('data-account-tab-btn');
        activateTab(tabId);
      });
    });

    // Check initial hash
    const initialHash = window.location.hash.replace('#', '');
    if (initialHash && document.querySelector(`[data-account-tab-panel="${initialHash}"]`)) {
      activateTab(initialHash);
    } else {
      activateTab('overview');
    }
  }

  /* --------------------------------------------------------------------------
     4. Address Management Form Controls
     -------------------------------------------------------------------------- */
  function initAddressToggles() {
    const addBtn = document.getElementById('AddAddressBtn');
    const addForm = document.getElementById('AddAddressForm');
    const cancelAddBtn = document.getElementById('CancelAddAddressBtn');

    if (addBtn && addForm) {
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        addForm.classList.toggle('rb-hide');
        addBtn.scrollIntoView({ behavior: 'smooth' });
      });
    }

    if (cancelAddBtn && addForm) {
      cancelAddBtn.addEventListener('click', (e) => {
        e.preventDefault();
        addForm.classList.add('rb-hide');
      });
    }

    // Edit address toggles
    document.querySelectorAll('[data-edit-address-btn]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const formId = btn.getAttribute('data-edit-address-btn');
        const formEl = document.getElementById(`EditAddress_${formId}`);
        if (formEl) {
          formEl.classList.toggle('rb-hide');
          formEl.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    document.querySelectorAll('[data-cancel-edit-btn]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const formId = btn.getAttribute('data-cancel-edit-btn');
        const formEl = document.getElementById(`EditAddress_${formId}`);
        if (formEl) {
          formEl.classList.add('rb-hide');
        }
      });
    });
  }

  /* --------------------------------------------------------------------------
     5. Header Account Popover Dismissals
     -------------------------------------------------------------------------- */
  function initHeaderAccountPopover() {
    const accountWrap = document.querySelector('.rb-header-account-wrap');
    if (!accountWrap) return;

    const trigger = accountWrap.querySelector('[data-account-popover-trigger]');
    const popover = accountWrap.querySelector('.rb-header-account-popover');
    if (!trigger || !popover) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      popover.classList.toggle('is-open');
    });

    document.addEventListener('click', (e) => {
      if (!accountWrap.contains(e.target)) {
        popover.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        popover.classList.remove('is-open');
      }
    });
  }

  /* --------------------------------------------------------------------------
     Initialize on DOM Ready
     -------------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    initPasswordToggles();
    initRecoverFormSwitcher();
    initAccountTabs();
    initAddressToggles();
    initHeaderAccountPopover();
  });

})();

